import React from "react";
import { Box, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/react";

interface Props {
  isOpen: boolean;
  handleOpen: () => void;
  handleClose: () => void;
  title: string;
  children?: React.ReactNode;
  size?: "sm" | "md" | "lg";
  type?: "logout" | "delete";
  confirm?: boolean;
  setConfirm?: (open: boolean) => void;
  onCloseComplete?: () => void;
  isLoading?: boolean;
}

function ModalBox({ isOpen, handleOpen, handleClose, title, children, size, type, confirm, setConfirm, onCloseComplete, isLoading }: Props) {
  return (
    <Box zIndex={'1'}>
      <Modal
        onClose={handleClose}
        isOpen={isOpen}
        scrollBehavior={"inside"}
        onCloseComplete={onCloseComplete}

      >
        <ModalOverlay zIndex={'1'} />
        <ModalContent
          minH={'fit-content'}
          zIndex={"1"}
          minWidth={{
            lg: size === "sm" ? "40vw" : size === "lg" ? "80vw" : "60vw",
            md: size === "lg" ? "98vw" : "80vw",
            base: "98vw",
          }}
        >
          <ModalHeader fontSize={"15px"}>{title}</ModalHeader>
          <ModalCloseButton
            onClick={() => {
              handleOpen();
            }}
            _focus={{
              outline: "none",
              boxShadow: "none",
              svg: {
                fontSize: "11px",
              },
            }}
          />
          <ModalBody zIndex={1}>
            {type === "logout" && !children && <div>Are you sure you want to logout?</div>}
            {type === "delete" && !children && <div>Are you sure you want to delete?</div>}
            {children}
          </ModalBody>
          {type === "delete" ||
          type === "logout"  ? (
            <ModalFooter
              zIndex={1}
              sx={{
                display: "flex",
                gap: "1rem",
              }}
            >
              <Button
                size="sm"
                colorScheme={"red"}
                variant="outline"
                onClick={() => {
                  handleClose();
                }}
              >
                Cancel
              </Button>
              <Button
                size="sm"
                variant="primary"
                isLoading={isLoading}
                loadingText="Loading..."
                onClick={() => {
                  if (setConfirm !== undefined) setConfirm(true);
                }}
              >
                Confirm
              </Button>
            </ModalFooter>
          ) : (
            ""
          )}
        </ModalContent>
      </Modal>
    </Box>
  );
}

export default ModalBox;
